import React, { Component } from 'react'
import { Location } from '@reach/router'
import { Link } from 'gatsby'
import { Menu, X } from 'react-feather'
import Logo from './Logo'
import './Nav.css'
import MyContext from './Context'

export class Navigation extends Component {
  state = {
    active: false,
    activeSubNav: false,
    currentPath: false,
    minimizeLogoHeight: false
  }

  archiveFlags = ['library', 'video-reportage', 'reports']

  componentDidMount = () =>
    this.setState({ currentPath: this.props.location.pathname })

  handleMenuToggle = () => this.setState({ active: !this.state.active })

  // Only close nav if it is open///
  handleLinkClick = () => this.state.active && this.handleMenuToggle()

  render() {
    const { active } = this.state,
      NavLink = ({ to, className, children, ...props }) => (
        <Link
          to={to}
          className={`NavLink ${
            to === this.state.currentPath ? 'active' : ''
          } ${className}`}
          onClick={this.handleLinkClick}
          {...props}
        >
          {children}
        </Link>
      )

    return (
      <MyContext.Consumer>
        {cons => (
          <nav className={`Nav ${active ? 'Nav-active' : ''}`}>
            <div
              className="Nav--Container"
              style={{
                height: 'auto',
                marginRight: '30px',
                marginLeft: '30px'
              }}
            >
              <div>
                <Link to="/" onClick={this.handleLinkClick}>
                  <Logo minimizeLogoHeight={this.state.minimizeLogoHeight} />
                </Link>
              </div>

              <div className="Nav--Links" style={{}}>
                <NavLink to="/">{cons.strings('ourMovement')}</NavLink>
                <NavLink to="/post-categories/main-article/">
                  {cons.strings('freeWord')}
                </NavLink>

                <NavLink to="/post-categories/announcements/">
                  {cons.strings('announcements')}
                </NavLink>
                <NavLink to="/post-categories/featured/">
                  {cons.strings('mokh')}
                </NavLink>
                {/* <NavLink to="/post-categories/discussions/">
                {cons.strings('discussion')}
              </NavLink> */}

                <NavLink exact="true" to="/library/">
                  {cons.strings('library')}
                </NavLink>

                <NavLink to="/areeg/">{cons.strings('Arts')}</NavLink>
                <NavLink to="/gate/">{cons.strings('gate')}</NavLink>
                <div
                  type="button"
                  style={{
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    color: '#41942f',
                    fontSize: '16px',
                    fontWeight: 'bolder',
                    textDecoration: 'underline transparant'
                  }}
                  onClick={() =>
                    cons.i18n.language == 'en'
                      ? cons.i18n.changeLanguage('ar')
                      : cons.i18n.changeLanguage('en')
                  }
                >
                  {cons.i18n.language == 'en' ? 'العربية' : 'English'}
                </div>
              </div>
              <div />

              <button
                className="Button-blank Nav--MenuButton"
                onClick={this.handleMenuToggle}
              >
                {active ? <X /> : <Menu />}
              </button>
            </div>
          </nav>
        )}
      </MyContext.Consumer>
    )
  }
}

export default ({ subNav }) => (
  <Location>{route => <Navigation subNav={subNav} {...route} />}</Location>
)
